import React from 'react'
import PropTypes from 'prop-types'
import Page from '../../containers/PrepaymentPage'

const Prepayment = () => (
    <React.Fragment>
        <Page />
    </React.Fragment>
)

Prepayment.propTypes = {
    children: PropTypes.node
}

export default Prepayment